import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { App } from '@df/core/app';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { RatingComponent } from '../../../../../ui/common/rating.component';
import { CMS_COMPONENT_CWV_CONFIG, ICmsComponentCwvConfig } from '../../../../config/component.config';
import { AllReviewsComponent } from '../../../review/all-reviews/all-reviews.component';

export interface IBannerReviewsComponentData extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
    image?: string;
    title: string;
    copy?: string;
}

@ICmsComponent<BannerReviewsComponent>({
    id: 'banner-reviews',
    name: 'Banner Reviews',
    tags: ['Homepage', 'Banner', 'Reviews'],
    fields: [
        <NICmsContentField.IField>{
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image'
        },
        <NICmsContentField.IField>{
            key: 'title',
            title: 'Title',
            type: NICmsContentField.EFieldType.text,
            required: true,
            default: 'Lorem ipsum'
        },
        <NICmsContentField.IField>{
            key: 'copy',
            title: 'Copy',
            type: NICmsContentField.EFieldType.textarea
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
})
@Component({
    selector: 'banner-reviews',
    templateUrl: './banner-reviews.html',
    standalone: true,
    imports: [AllReviewsComponent, CommonModule, DfImageDirective, ICmsClientModule, IfSizeDirective, RatingComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerReviewsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IBannerReviewsComponentData;

    protected app = inject(App);

    get rating(): number {
        return this.app.data.reviews ? this.app.data.reviews.rating_summary / 20 : 0;
    }

    get ratingText(): string {
        return this.rating.toFixed(2);
    }
}
